import App from './App.svelte'

const target = document.querySelector('#customer-app')
const currentCustomer = target.getAttribute('data-customer')

const app = new App({
  target: target,
  props: {
    customer: currentCustomer,
  },
})

window.app = app

export default app
